import axios from 'axios';

export default {
    getAll() {
        return axios.get(window.API_BASE + '/settings/deductions');
    },

    store(params) {
        return axios.post(window.API_BASE + '/settings/deductions', params);
    },

    update(id, params) {
        return axios.put(window.API_BASE + '/settings/deductions/' + id, params);
    },

    delete(id) {
        return axios.delete(window.API_BASE + '/settings/deductions/' + id);
    }
}